import { Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import type { SummaryReport } from '../../../types.ts';
import { dialogSectionSx } from '../dialogStyles.ts';

const confirmSx = {
    ...dialogSectionSx,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    py: 4,
    borderColor: 'warning.light',
};

export default function ConfirmOverwrite({
    pendingReport,
}: {
    pendingReport: SummaryReport | null;
}) {
    return (
        <Box sx={confirmSx}>
            <WarningAmberIcon color='warning' sx={{ fontSize: 48 }} />
            <Typography variant='body1' textAlign='center'>
                Loading {pendingReport ? `"${pendingReport.name}"` : 'this report'} will replace
                your current filter and grid layout.
            </Typography>
            <Typography variant='body2' color='text.secondary' textAlign='center'>
                Any unsaved changes to your current view will be lost.
            </Typography>
        </Box>
    );
}
